import Vue from 'vue'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'

import axios from 'axios'
import { loadProgressBar } from 'axios-progress-bar'
import 'axios-progress-bar/dist/nprogress.css'

import router from './router'

import { store } from './store/store'

import App from './App.vue'
// global components
import GlobalComponents from './globalComponents'

Vue.use(Buefy, {
    defaultIconPack: 'mdi',
})

window.Vue = Vue;

Vue.use(GlobalComponents);

// navigation guards before each
router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.requiresAuth)) {
		// this route requires auth, check if logged in
		// if not, redirect to login page.
		if (localStorage.getItem('accessToken') === null) {
			next({
				path: '/login',
				query: { redirect: to.fullPath }
			})
		} else {
			next()
		}
	} else {
		next() // make sure to always call next()!
	}
})

axios.defaults.baseURL = 'https://freytax.com/admin-panel'
axios.defaults.headers.common = {
  'Accept': 'application/json',
  'Content-Type': 'application/json'
};

loadProgressBar()

Vue.mixin({
	data() {
		return {
			dataGrid: {
				isPaginated: true,
                isPaginationSimple: true,
                defaultSortDirection: 'asc',
                currentPage: 1,
                perPage: 20,
                checkedRows: []
            },
			weekdays: [
                { id: 1, day_name: 'Lunes'},
                { id: 2, day_name: 'Martes'},
                { id: 3, day_name: 'Miércoles'},
                { id: 4, day_name: 'Jueves'},
                { id: 5, day_name: 'Viernes'},
                { id: 6, day_name: 'Sábado'},
                { id: 7, day_name: 'Domingo'}
            ],
			weekdays_1: [
                { id: 7, day_name: 'Domingo'},
                { id: 1, day_name: 'Lunes'},
                { id: 2, day_name: 'Martes'},
                { id: 3, day_name: 'Miércoles'},
                { id: 4, day_name: 'Jueves'},
                { id: 5, day_name: 'Viernes'},
                { id: 6, day_name: 'Sábado'}
            ],
            monthNamePropArray: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
            yearNameArray: [
                2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025
            ]
        }
    },
    computed: {
        getDeletableRows() {
            let checkedRows = []
            
            this.dataGrid.checkedRows.forEach(element => {
                checkedRows.push(element.id)
            });
            return checkedRows
        }
    },
    methods: {
        isDateRangeValid(startDate, endDate) {
            var fDate = new Date(startDate);
            var lDate = new Date(endDate);
            if(fDate <= lDate) {
                return true;
            }
            return false;
        },
        deleteRows(actionPath, listActionName, payload = null) {

            if(this.getDeletableRows.length == 0) {
                this.$store.commit('setAlertBox', {title: 'Error', message: 'message.pleaseSelectAleastOneRowToDelete'})
                return
            }
            this.$store.commit('setConfirmBox', 
            {
                title: 'message.warning', message: '¿Estás seguro de proceder?',
                followingAction: {
                    target: 'deleteData',
                    permissions: this.$store.getters.getCurrentPathProps,
                    targetParameters: {actionPath, listActionName, data: this.getDeletableRows, payload},
                    targetAction: 2,
                }
            }
            )

        },
        deleteIndividualData(actionPath, listActionName, deleteData, payload = null) {

            this.$store.commit('setConfirmBox', 
            {
                title: 'message.warning', message: '¿Estás seguro de proceder?',
                followingAction: {
                    target: 'deleteData',
                    permissions: this.$store.getters.getCurrentPathProps,
                    targetParameters: {actionPath, listActionName, data: deleteData, payload},
                    targetAction: 2,
                }
            }
            )

        },
        getAsyncAutocompleteData(event, queryProp, url) {
            
            if(event.code == 'ArrowUp' || event.code == 'ArrowDown') {

            } else {
                this.$store.dispatch('fetchAutocompleteQuery', { query: queryProp, search: true, url })
            }
            
        },
        monthDiff(d1, d2) {
          
          if(d1 != null && d2 !=null) {
            var months;
            months = (d2.getFullYear() - d1.getFullYear()) * 12;
            months -= d1.getMonth() + 1;
            months += d2.getMonth();
            return months <= 0 ? 0 : months+1;
          } else {
            return 0
          }
        },
        dayDiff(d1, d2) {
          
          if(d1 != null && d2 !=null) {
            return Math.floor((Date.UTC(d2.getFullYear(), d2.getMonth(), d2.getDate()) - Date.UTC(d1.getFullYear(), d1.getMonth(), d1.getDate()) ) /(1000 * 60 * 60 * 24));
          } else {
            return 0
          }
        },
        produceSavableDate(dateVal) {
            let dd = new Date(dateVal)
            let mm = (dd.getMonth()+1)
            if(mm <9) {
                mm = "0"+mm
            }
            let day = dd.getDate()
            if(day <9) {
                day = "0"+day
            }
            let returnDate = dd.getFullYear()+"/"+mm+"/"+day

            return returnDate
        },
        formatCurrency(value, formatCurrency = true, localeInfo1 = this.$store.getters.getUserauthResponse) {
            //let localeInfo = this.$store.getters.getUserauthResponse
              let localeInfo = localeInfo1.locale_info
              if(formatCurrency) {
                  
                  var n = value, 
                  c = localeInfo.decimal_allowed ? 2 : 0, 
                  d = localeInfo.decimal_separator, 
                  t = localeInfo.thousand_separator, 
                  s = n < 0 ? "-" : "", 
                  i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))), 
                  j = (j = i.length) > 3 ? j % 3 : 0;
                  
                  if(localeInfo.decimal_allowed) {
                      return localeInfo.currency_symbol+" "+s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
                  } else {
                      return localeInfo.currency_symbol+" "+s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t);
                  }
                  
                
              } else {
                  return (value).toFixed(localeInfo.maxFraction)
              }
        },
        formatCurrencyNoPrefix(value, formatCurrency = true, localeInfo1 = this.$store.getters.getUserauthResponse) {
            //let localeInfo = this.$store.getters.getUserauthResponse
              let localeInfo = localeInfo1.locale_info
              if(formatCurrency) {
                
                  var n = value, 
                  c = localeInfo.max_fraction, 
                  d = localeInfo.decimal_separator, 
                  t = localeInfo.thousand_separator, 
                  s = n < 0 ? "-" : "", 
                  i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))), 
                  j = (j = i.length) > 3 ? j % 3 : 0;
                  
                  if(localeInfo.max_fraction>0) {
                      return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
                  } else {
                      return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t);
                  }
                  
                
              } else {
                  return (value).toFixed(localeInfo.maxFraction)
              }
        },
        changeDate(value, $offset = false) {

            var monthNames = [
                'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
            ];
            
            let date = new Date(value)
            if($offset) {
                date = new Date( date.getTime() + Math.abs(date.getTimezoneOffset()*60000) )
            }

            var day = date.getDate();
            var monthIndex = date.getMonth();
            var year = date.getFullYear();
            
            if(day<10) {
                day = "0"+day
            }
            return day + ' ' + monthNames[monthIndex] + ' ' + year;

        },
        changeDateTime(value) {

            return this.changeDate(value)+', '+value.substring(value.indexOf(' '))   

        },
        changeTime(value) {

            let date = new Date(value)
            
            var hour = date.getHours();
            var minutes = date.getMinutes();
            
            if(hour<10) {
                hour = "0"+hour
            }
            if(minutes<10) {
                minutes = "0"+minutes
            }
            return hour + ':' + minutes;

        },
        isNumber(evt) {
            console.log(evt)
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            }
		},
		
    }
})

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js